import React, { Fragment, useEffect } from 'react'
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider
} from '@mui/material'
import {
  Sell as SellIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  EventAvailable as EventAvailableIcon,
  Update as UpdateIcon
} from '@mui/icons-material'
import { getOrderOriginById } from '../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { OrderOriginInfoDto } from '../../../interfaces/OrderOrigin/OrderOrigin'

interface ViewOrderOriginModalProps {
  orderOriginId: number
  handleSnackbar: (message: string, success: boolean) => void
}

const formatDate = (date: string | null) => {
  if (!date) return '-'
  return new Date(date).toLocaleString()
}

export const ViewOrderOriginModal: React.FC<ViewOrderOriginModalProps> = ({
  orderOriginId,
  handleSnackbar
}) => {
  const { state, callApi } = useApi<OrderOriginInfoDto>()

  const requestOrderOrigin = () => {
    callApi(getOrderOriginById(orderOriginId))
      .then(() => {})
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  useEffect(() => {
    requestOrderOrigin()
  }, [])

  if (state.status === Status.Loading)
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <SellIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Canal de Venta'
            secondary={state.data?.origin}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              {state.data?.active ? <CheckCircleIcon /> : <CancelIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Estado'
            secondary={state.data?.active ? 'Activo' : 'Inactivo'}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <UpdateIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Última Modificación'
            secondary={formatDate(state.data?.lastModifiedAt ?? null)}
          />
        </ListItem>
      </List>
    </Fragment>
  )
}
